import MUIStack from "@mui/material/Stack";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import InfoItem from "../InfoItem";
import ReportSetting from "../ReportSetting";
import MainContext from "../../Context/MainContext/MainContext";
import OrderActivityType from "../../Utility/Crud/OrderActivityType";

export default class ReportSettingOrderActivityType extends ReportSetting {
  static contextType = MainContext; // For legacy class components

  /**
   * Renders OrderActivityType dropdown for selecting multiple order activity types.
   */
  renderOrderActivityTypeDropdown() {
    const handleOrderActivityTypeChange = (e, orderActivityType) => {
      this.handleSettingChange(
        "orderActivityTypes",
        orderActivityType
          ? orderActivityType.map((orderActivityType) => orderActivityType.name)
          : [],
      );
    };

    return (
      <MUIAutocomplete
        multiple={true}
        options={OrderActivityType.sort(
          Object.values(this.context.orderActivityTypesIndexed),
        )}
        value={OrderActivityType.read(this.context.orderActivityTypesIndexed, [
          {
            key: "name",
            value: this.state.settings.orderActivityTypes || [],
          },
        ])}
        getOptionLabel={(option) => OrderActivityType.getDisplayName(option)}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        onChange={handleOrderActivityTypeChange}
        sx={{ width: "300px" }}
        renderInput={(params) => {
          return (
            <MUITextField
              {...params}
              InputLabelProps={{ shrink: true }}
              size="small"
              label="Order Type"
              variant="standard"
              InputProps={{
                ...params.InputProps,
              }}
            />
          );
        }}
      />
    );
  }

  renderContent() {
    return (
      <MUIStack direction="row" spacing={2} alignItems="center">
        {this.renderOrderActivityTypeDropdown()}
      </MUIStack>
    );
  }

  renderReadOnly() {
    if (
      !this.state.settings.orderActivityTypes ||
      this.state.settings.orderActivityTypes.length === 0
    ) {
      return <InfoItem label="Order Type" value="All Types" />;
    }

    const types = OrderActivityType.read(
      this.context.orderActivityTypesIndexed,
      [{ key: "name", value: this.state.settings.orderActivityTypes }],
    );

    const typeNames = types
      .map((type) => OrderActivityType.getDisplayName(type))
      .join(", ");
    return <InfoItem label="Order Type" value={typeNames} />;
  }
}
